import React from "react";
import { useLocation } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { useLang } from "@/i18n";
import { Reveal } from "@/components/site/motion";
import ContactForm from "@/components/site/ContactForm";
import { CONTACT, IMAGES } from "@/data/content";
import Seo from "@/components/site/Seo";

export default function Contatti() {
    const { t } = useLang();
    const params = new URLSearchParams(useLocation().search);
    const isQuote = params.get("quote") === "1";

    const info = [
        { icon: Phone, label: t.contactPage.phone, value: `${CONTACT.phone} · ${CONTACT.mobile}`, href: `tel:+39${CONTACT.phone.replace(/\s/g, "")}` },
        { icon: Mail, label: t.contactPage.email, value: CONTACT.emails[0], href: `mailto:${CONTACT.emails[0]}` },
        { icon: MapPin, label: t.contactPage.address, value: CONTACT.address },
        { icon: Clock, label: t.contactPage.hours, value: t.contactPage.hoursValue },
    ];

    return (
        <>
            <Seo title={t.seo.contact.t} description={t.seo.contact.d} image={IMAGES.about} path="/contatti" />
            <section className="relative pt-40 pb-24 bg-cb-dark cb-grid overflow-hidden">
                <div className="absolute inset-0 opacity-20">
                    <img src={IMAGES.about} alt="" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-cb-darker/80" />
                </div>
                <div className="relative max-w-7xl mx-auto px-6">
                    <Reveal className="text-cb-accent text-xs uppercase tracking-[0.3em] mb-4">{isQuote ? t.nav.quote : t.contactPage.title}</Reveal>
                    <Reveal as="h1" delay={0.4} className="font-display text-5xl md:text-6xl font-bold tracking-tighter text-white">{t.contactPage.title}</Reveal>
                    <Reveal delay={0.8} className="mt-6 max-w-2xl text-slate-300 text-lg">{t.contactPage.sub}</Reveal>
                </div>
            </section>

            <section className="py-20 md:py-28 bg-white">
                <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-16">
                    <div>
                        <div className="grid sm:grid-cols-2 gap-px bg-slate-200 mb-10">
                            {info.map((it, i) => {
                                const Icon = it.icon;
                                const inner = (
                                    <div className="bg-white p-6 h-full">
                                        <Icon size={26} strokeWidth={1.4} className="text-cb-accent" />
                                        <div className="mt-4 text-xs uppercase tracking-widest text-slate-400">{it.label}</div>
                                        <div className="mt-1 text-cb-dark font-medium">{it.value}</div>
                                    </div>
                                );
                                return (
                                    <Reveal key={i} delay={i * 0.3}>
                                        {it.href ? <a href={it.href} data-testid={`contact-info-${i}`} className="block h-full hover:bg-cb-light transition-colors">{inner}</a> : <div data-testid={`contact-info-${i}`}>{inner}</div>}
                                    </Reveal>
                                );
                            })}
                        </div>
                        <Reveal delay={0.5} className="overflow-hidden border border-slate-200">
                            <iframe title="Mappa Gruppo CB" src={CONTACT.mapsEmbed} width="100%" height="320" style={{ border: 0 }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" data-testid="contact-map" />
                        </Reveal>
                    </div>

                    <Reveal delay={0.4}>
                        <div className="bg-cb-light border border-slate-200 p-8 md:p-10">
                            <h2 className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-cb-dark">
                                {isQuote ? t.finalCta.btn : t.contactPage.title}
                            </h2>
                            <p className="mt-2 text-slate-500 text-sm mb-8">{t.contactPage.sub}</p>
                            <ContactForm kind={isQuote ? "quote" : "contact"} />
                        </div>
                    </Reveal>
                </div>
            </section>
        </>
    );
}
